import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  if (document.querySelector(".splide01")) {
    new Splide(".splide01", {
      type: "loop",
      perPage: 3,
      perMove: 1,
      autoplay: true,
      interval: 3000,
      pauseOnHover: false,
      focus: 0,
    }).mount();
  }

  if (document.querySelector(".splide02")) {
    new Splide(".splide02", {
      autoplay: true,
      type: "fade",
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 6000,
      speed: 5000,
      arrows: false,
      pagination: false,
    }).mount();
  }

  if (document.querySelector(".splide03")) {
    new Splide(".splide03", {
      perPage: 3,
      type: "loop",
      focus: 0,
      autoScroll: {
        speed: 2,
      },
    }).mount({ AutoScroll });
  }
}
